import api from "./api";

export const getMark = async(active: boolean | null, name?: string) => {
    const params = new URLSearchParams();
    if (active !== null) params.append("active", String(active));
    if (name) params.append("name", name);
    const query = params.toString();

    const response = await api.get(`mark/listAll${query ? `?${query}` : ""}`);
    return response.data;
};

export const getQtdMark = async() => {
    const response = await api.get(`mark/listQtd`);
    return response.data;
};